/**
Author - Venkatesh Pullaganti 😃
Git - https://github.com/venkatesh1146
**/

import {baseTheme} from './Theme';

export const clientTheme = {
  ...baseTheme,
  name: 'client',

  // Colors
  colors: {
    ...baseTheme.colors,
    brand: {
      primary: '#6725F4',
      secondary: '#F8F2FF',
      tertiary: '#8670CC',
    },
    text: {
      primary: '#000000',
      secondary: '#7E7E7E',
      disabled: '#AAAAAA',
    },
    background: {
      primary: '#FFFFFF',
      secondary: '#F8F2FF',
    },
    feedback: {
      error: '#FF7262',
      success: '#41B76F',
      warning: '#FFA63E',
      successLight: '#D9F9E8',
    },
    gradient: {
      primary: 'linear-gradient(90deg, #6F2FF 0%, #FF6B8B 100%)',
    },
  },

  // Typography
  typography: {
    fontFamily: {
      primary: 'Maven, sans-serif',
      secondary: 'MavenPro, sans-serif',
    },
    fontWeight: {
      regular: 400,
      medium: 500,
      semiBold: 600,
      bold: 700,
    },
    // Simple rem values - automatically responsive via CSS root font-size
    fontSize: {
      xxs: '0.857rem', // Auto-scales: ~10.2px → 12px
      xs: '1rem', // Auto-scales: ~11.9px → 14px
      sm: '1.143rem', // Auto-scales: ~13.6px → 16px
      md: '1.286rem', // Auto-scales: ~15.3px → 18px
      lg: '1.429rem', // Auto-scales: ~17px → 20px
      sxl: '1.571rem', // Auto-scales: ~18.7px → 22px
      xl: '1.714rem', // Auto-scales: ~20.4px → 24px
      xxl: '2.286rem', // Auto-scales: ~27.2px → 32px
      xxxl: '2.857rem', // Auto-scales: ~34px → 40px
    },
    lineHeight: {
      tight: 1.2,
      normal: 1.5,
      loose: 1.8,
    },
    styles: {
      display: {
        fontFamily: 'Maven, sans-serif',
        fontSize: '2.857rem', // Auto-scales: ~34px → 40px
        fontWeight: 700,
        lineHeight: 1.2,
      },
      heading: {
        1: {
          fontFamily: 'Maven, sans-serif',
          fontSize: '2.286rem', // Auto-scales: ~27.2px → 32px
          fontWeight: 700,
          lineHeight: 1.2,
        },
        2: {
          fontFamily: 'Maven, sans-serif',
          fontSize: '1.714rem', // Auto-scales: ~20.4px → 24px
          fontWeight: 600,
          lineHeight: 1.2,
        },
        3: {
          fontFamily: 'Maven, sans-serif',
          fontSize: '1.429rem', // Auto-scales: ~17px → 20px
          fontWeight: 600,
          lineHeight: 1.3,
        },
      },
      body: {
        large: {
          fontFamily: 'Maven, sans-serif',
          fontSize: '1.429rem', // Auto-scales: ~17px → 20px
          fontWeight: 400,
          lineHeight: 1.5,
        },
        largeSemibold: {
          fontFamily: 'Maven, sans-serif',
          fontSize: '1.429rem', // Auto-scales: ~17px → 20px
          fontWeight: 600,
          lineHeight: 1.5,
        },
        medium: {
          fontFamily: 'Maven, sans-serif',
          fontSize: '1.286rem', // Auto-scales: ~15.3px → 18px
          fontWeight: 400,
          lineHeight: 1.5,
        },
        regular: {
          fontFamily: 'Maven, sans-serif',
          fontSize: '1.143rem', // Auto-scales: ~13.6px → 16px
          fontWeight: 400,
          lineHeight: 1.5,
        },
        small: {
          fontFamily: 'Maven, sans-serif',
          fontSize: '1rem', // Auto-scales: ~11.9px → 14px
          fontWeight: 400,
          lineHeight: 1.5,
        },
      },
      cta: {
        fontFamily: 'Maven, sans-serif',
        fontSize: '1.286rem', // Auto-scales: ~15.3px → 18px
        fontWeight: 600,
        lineHeight: 1.5,
        textTransform: 'uppercase',
      },
      label: {
        fontFamily: 'Maven, sans-serif',
        fontSize: '1.143rem', // Auto-scales: ~13.6px → 16px
        fontWeight: 500,
        lineHeight: 1.5,
      },
      express: {
        fontFamily: 'Maven, sans-serif',
        fontSize: '1.143rem', // Auto-scales: ~13.6px → 16px
        fontWeight: 600,
        lineHeight: 1.5,
      },
    },
  },
};
